
enum SearchEvents {
    SearchStarted = "[Search] SearchStarted",
    SearchCompleted = "[Search] SearchCompleted",
    UnselectFacet = "[Search] UnselectFacet",
    SelectFacet = "[Search] SelectFacet",
    ClearSearchResult = "[Search] ClearSearchResult"
}

export default SearchEvents;
